import { useNavigate, useSearchParams } from 'react-router-dom';
import UserNavbar from '../../components/UserNavbar';
import { toast } from 'react-toastify';

function PaymentFailed() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error') || 'Payment processing failed';

  return (
    <div className="bg-light min-vh-100">
      <UserNavbar />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card border-0 shadow-sm rounded-4 text-center">
              <div className="card-body p-5">
                <div className="mb-4">
                  <div className="error-icon mb-3">
                    <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: '5rem' }}></i>
                  </div>
                  <h2 className="fw-bold text-danger mb-3">Payment Failed</h2>
                  <p className="text-muted mb-3">
                    {error}
                  </p>
                </div>

                <div className="alert alert-warning" role="alert">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  Your payment could not be processed. Please try again or contact support if the problem persists.
                </div>

                <div className="d-grid gap-2">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={() => navigate(-1)}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Try Again
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => navigate('/user/dashboard')}
                  >
                    <i className="bi bi-house me-2"></i>
                    Go to Dashboard
                  </button>
                </div>

                <div className="mt-4 pt-4 border-top">
                  <p className="text-muted small mb-0">
                    <i className="bi bi-shield-exclamation me-1"></i>
                    If you were charged, the amount will be refunded within 5-7 business days.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentFailed;
